import { get } from 'lodash';
import { getPageLoadMetrics } from '../../services/performance-tracker';
import { TRACK_PERFORMANCE } from '../../actions/track-performance';

const handler = action => {
  const context = get(action, 'payload.context');
  if (!context) {
    return;
  }

  const metrics = getPageLoadMetrics();
  if (!metrics) {
    return;
  }

  return {
    evid: 2003,
    initial_connection_time: metrics.timeToFirstByte,
    content_transfer_time: metrics.contentTransfer,
    content_transfer_size: metrics.transferSize,
    dom_interactive: metrics.domInteractive,
    dom_content_load: metrics.domContentLoad,
    context,
    eventMeta: {
      description: 'page load metrics',
    },
  };
};

export const uouPerformanceEvent = { [TRACK_PERFORMANCE]: handler };
